// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AdministrativeAreasController from "./administrative_areas_controller"
application.register("administrative-areas", AdministrativeAreasController)

import AjaxSubmitterController from "./ajax_submitter_controller"
application.register("ajax-submitter", AjaxSubmitterController)

import CharacterCounterController from "./character_counter_controller"
application.register("character-counter", CharacterCounterController)

import CheckboxLimitController from "./checkbox_limit_controller"
application.register("checkbox-limit", CheckboxLimitController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import DependentSelectController from "./dependent_select_controller"
application.register("dependent-select", DependentSelectController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import FieldToggleController from "./field_toggle_controller"
application.register("field-toggle", FieldToggleController)

import InfiniteScrollController from "./infinite_scroll_controller"
application.register("infinite-scroll", InfiniteScrollController)

import ListboxController from "./listbox_controller"
application.register("listbox", ListboxController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import PopupWindowController from "./popup_window_controller"
application.register("popup-window", PopupWindowController)

import PushStateController from "./push_state_controller"
application.register("push-state", PushStateController)

import SearchFormController from "./search_form_controller"
application.register("search-form", SearchFormController)

import TextCounterController from "./text_counter_controller"
application.register("text-counter", TextCounterController)

import ToggleActiveController from "./toggle_active_controller"
application.register("toggle-active", ToggleActiveController)

import VideoLoadController from "./video_load_controller"
application.register("video-load", VideoLoadController)

import VideoSearchController from "./video_search_controller"
application.register("video-search", VideoSearchController)
